import { ErrorMessage } from "@/app/components/error-message";
import { Button, buttonVariants } from "@/components/ui/button";
import { useNotificationStore } from "@/features/notifications/utils/notification-store";
import { useGetOrganisation } from "@/features/organisations/api/get-organisation";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { RoleEnum } from "@classview/shared-types";

export function StorageCapacityNotice() {
  const { hasPermission, organisation } = useOrganisation();
  const { isStorageNoticeDismissed, setIsStorageNoticeDismissed } =
    useNotificationStore();
  const { isLoading, isSuccess, isError, error, data } = useGetOrganisation(
    {
      id: organisation.id,
    },
    {
      enabled: hasPermission(RoleEnum.ORGANISATION_MANAGEMENT),
    },
  );

  if (!hasPermission(RoleEnum.ORGANISATION_MANAGEMENT) || isLoading) {
    return null;
  }

  if (isError || !isSuccess) {
    return <ErrorMessage error={error} />;
  }

  const usedStorageGB = Number(
    (data.totalStorageUsedBytes / (1024 * 1024 * 1024)).toFixed(2),
  );
  const totalStorageGB = data.license.storageInGB;
  const usedPercentage =
    totalStorageGB > 0
      ? Math.min(Math.round((usedStorageGB / totalStorageGB) * 100), 100)
      : 0;

  if (usedPercentage < 80) {
    return null;
  }

  if (isStorageNoticeDismissed) {
    return null;
  }

  const handleDismiss = () => {
    setIsStorageNoticeDismissed(true);
  };

  return (
    <div className="rounded-md border border-border bg-background px-3 py-4">
      <p className="text-sm font-semibold text-foreground">Storage Capacity</p>
      <p className="mb-4 text-sm text-muted">
        Your organisation has used {usedPercentage}% of your available storage.
        Need more?
      </p>

      <div className="relative h-2 w-full rounded-md bg-card">
        <div
          className="absolute left-0 top-0 h-full rounded-md bg-primary transition-all"
          style={{ width: `${usedPercentage}%` }}
        />
      </div>
      <div className="mt-4 flex items-center gap-2">
        <Button variant="outline" onClick={handleDismiss}>
          Dismiss
        </Button>
        <a
          href="https://classview.com/contact-us?utm_source=classview-license-page&utm_medium=referral"
          target="_blank"
          rel="noopener noreferrer"
          className={buttonVariants({ variant: "link" })}
        >
          Contact Sales
        </a>
      </div>
    </div>
  );
}
